import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import { Box } from '@mui/material';
import { useDialog } from '../../shared/context';
import TableCustom from '../common/table/TableCustomRow';

const ViewedDocumentsDialog = ({ handleClose, handleCancel, dialogData }) => {
  const showViewedDocumentsDialog = useDialog('showViewedDocumentsDialog');
  const columns = [
    { id: 'user_name', label: 'Usuário', align: 'left' },
    { id: 'originalname', label: 'Title', align: 'center' },
    { id: 'sector', label: 'Setor', align: 'center' },
    { id: 'registration_date', label: 'Data da Leitura', aling: 'center' },
    { id: 'new_rereading', label: 'Data da Releitura', aling: 'center' },
  ];

  return (
    <Dialog
      open={showViewedDocumentsDialog.isDialogOpen()}
      onClose={handleClose}
      aria-describedby="alert-dialog-slide-description"
      maxWidth="90vw"
      fullWidth
    >
      <DialogContent>
        <Box p={2}>
          <TableCustom columns={columns} rows={dialogData} />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel} variant="contained" color="error">
          sair
        </Button>
        <Button onClick={handleCancel} variant="contained" color="success">
          ok
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ViewedDocumentsDialog;
